import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  CardDeck,
  Col,
  Collapse,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Label,
  Row,
  Table,
} from "reactstrap";
import React, { Fragment, useContext, useEffect, useState } from "react";
import PageHeader from "../common/PageHeader";
import FalconCardHeader from "../common/FalconCardHeader";
import {
  fetchDebtsToPayAsPropertyCuentaPendingPeriod,
  fetchDebtsToPayAsPropertyPendingTotal,
  fetchMyAliquotsAsProperty,
  findMyPaysAsProperty,
  GetMovementsProperty,
  GetMyBalance,
} from "../../helpers/api/finance";
import { isIterableArray } from "../../helpers/utils";
import { Link } from "react-router-dom";
import Datetime from "react-datetime";
import { useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDollarSign,
  faExclamationTriangle,
  faFilter,
  faInfo,
  faList,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { findConfigAsProperty } from "../../helpers/api/condominium";
import PropertyDebtToPayRow from "../common/PropertyDebtToPayRow";
import { Or, PreloadState } from "./../UI/preloading/PreloadState";
import CardSummary from "../UI/cards/CardSummary";
import withRedirect from "../../helpers/hoc/withRedirect";
import SupportLink from "../root/support/components/SupportLink";
import moment from "moment";
import useSWRFetchPaginationProperty from "../../helpers/hooks/useSWRFetchPaginationProperty";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import FullPagination from "../common/pagination/FullPagination";
import ButtonIcon from "../common/ButtonIcon";
import { CurrencyContext } from "../../context/Context";

const MyFinance = ({ setRedirect, setRedirectUrl }) => {
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { user } = useSelector((state) => state.auth);

  const [configSetted, setconfigSetted] = useState(false);
  const [loadingConfig, setloadingConfig] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [balance, setBalance] = useState({
    data: 0,
    loading: true,
    error: null,
  });
  const [configDate, setConfigDate] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [openPeriods, setOpenPeriods] = useState({});
  const [myPays, setMyPays] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [aliquots, setAliquots] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [formDate, setformDate] = useState({
    since: null,
    to: null,
  });

  const [params, setParams] = useState({
    state: 0,
    condominiumId: selectedCondominium,
  });

  const [param, setParam] = useState({
    start_date: null,
    end_date: null,
  });

  const [amount, setAmount] = useState(0);
  const [amountBs, setAmountBs] = useState(null);

  const {
    data: movementsData,
    isLoading: movementsIsLoading,
    handler: {
      goToPage: movementsGoToPage,
      nextPage: movementsNextPage,
      perPage: movementsPerPage,
      previousPage: movementsPreviousPage,
    },
    meta: movementsMeta,
  } = useSWRFetchPagination(GetMovementsProperty, param);
  

  const {
    data,
    isLoading: periodsIsLoading,
    meta: periodsMeta,
    handler: {
      goToPage: periodsGoToPage,
      nextPage: periodsNextPage,
      previousPage: periodsPreviousPage,
      perPage: periodsPerPage,
    },
  } = useSWRFetchPaginationProperty(
    fetchDebtsToPayAsPropertyCuentaPendingPeriod,
    params
  );

  const togglePeriod = (periodId) =>
    setOpenPeriods((prev) => ({ ...prev, [periodId]: !prev[periodId] }));

  const { currency: curr, baseCurrency } = useContext(CurrencyContext);

  const resolvePayDisplayRate = (pay) => {
    const rawStoredRate = pay?.exchange_rate?.value ?? pay?.exchange_rate ?? null;
    const storedRate = Number(rawStoredRate || 0);

    if (storedRate > 0) {
      return storedRate;
    }

    return Number(curr?.value || 1);
  };

  const filteredData = movementsData.map((item) => {
    try {
      const parsedDescription = JSON.parse(item.description);
      return { ...item, description: parsedDescription };
    } catch (error) {
      return item;
    }
  });

  const days = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
  ];

  const months = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const getDate = (date) => {
    const d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  const getStringDate = (date) => {
    const d = new Date(date);
    return `${days[d.getDay()]}, ${months[d.getMonth()]} ${d.getDate()}`;
  };

  useEffect(() => {
    let isMounted = true;
    if (selectedCondominium) {
      const getPendingTotal = async () => {
        try {
          const { total_amount, total_amount_bs } = await fetchDebtsToPayAsPropertyPendingTotal({
            condominiumId: selectedCondominium,
          });
          if (isMounted) {
            setAmount(total_amount);
            setAmountBs(total_amount_bs ?? null);
          }
        } catch (error) {
          if (isMounted) {
            setAmount(0);
            setAmountBs(null);
          }
        }
      };
      getPendingTotal();
    }
    return () => {
      isMounted = false;
    };
  }, [selectedCondominium]);


  useEffect(() => {
    let isMounted = true;
    if (user) {
      const getBalance = async () => {
        try {
          const {
            data: { balance },
          } = await GetMyBalance();
          isMounted &&
            setBalance((prev) => {
              return { ...prev, data: balance, loading: false };
            });
        } catch (error) {
          isMounted &&
            setBalance((prev) => {
              return { ...prev, error, loading: false };
            });
        }
      };
      getBalance();
    }
    return () => {
      isMounted = false;
    };
  }, [user]);

  useEffect(() => {
    let isMounted = true;
    if (selectedCondominium) {
      const getConfig = async () => {
        try {
          const { data } = await findConfigAsProperty(selectedCondominium);
          isMounted &&
            setConfigDate((prev) => {
              return { ...prev, data, loading: false };
            });
          if (data.automatic !== null) {
            isMounted && setconfigSetted(true);
          }
        } catch (error) {
          isMounted &&
            setConfigDate((prev) => {
              return { ...prev, error, loading: false };
            });
        } finally {
          isMounted && setloadingConfig(false);
        }
      };
      getConfig();
    }
    return () => {
      isMounted = false;
    };
  }, [selectedCondominium]);

  useEffect(() => {
    let isMounted = true;
    if (configSetted) {
      const getMyPays = async () => {
        try {
          const { data } = await findMyPaysAsProperty(1, 5, {
            condominiumId: selectedCondominium,
          });
          isMounted &&
            setMyPays((prev) => {
              return { ...prev, data, loading: false };
            });
        } catch (error) {
          isMounted &&
            setMyPays((prev) => {
              return { ...prev, error, loading: false };
            });
        }
      };
      const getMyAliquots = async () => {
        try {
          const { data } = await fetchMyAliquotsAsProperty();
          isMounted &&
            setAliquots((prev) => {
              return { ...prev, data, loading: false };
            });
        } catch (error) {
          isMounted &&
            setAliquots((prev) => {
              return { ...prev, error, loading: false };
            });
        }
      };
      getMyAliquots();
      getMyPays();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [configSetted]);

  const handleSeeToPay = () => {
    setRedirect(true);
    if (selectedCondominium) {
      setRedirectUrl(`/dashboard/my/finance/topay`);
    }
  };

  const handleSeeReports = () => {
    setRedirect(true);
    if (selectedCondominium) {
      setRedirectUrl(`/dashboard/my/finance/reports`);
    }
  };

  const handleSeePays = () => {
    setRedirect(true);
    if (selectedCondominium) {
      setRedirectUrl(`/dashboard/my/finance/pays`);
    }
  };

  return (
    <>
      <PageHeader
        title="Mis finanzas"
        titleTag="h2"
        description={"Visualiza tus finanzas en el condominio."}
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <Alert color="primary" className="shadow">
        <PreloadState
          cond={!!configDate.data?.charge_at}
          loadingClass="p-0"
          loading={configDate.loading}
        >
          <Row value={true}>
            <Col
              xs="auto"
              className="d-flex align-items-center justify-content-center"
            >
              <FontAwesomeIcon icon={faInfo} />
            </Col>
            <Col className="d-flex align-items-center">
              <p className="m-0">
                Recuerda que los días de pago del condominio son los días
                <b
                  className="mr-1 ml-1"
                  style={{ textDecoration: "underline" }}
                >
                  {configDate.data
                    ? configDate.data.charge_at
                      ? `${configDate.data.charge_at} de cada mes`
                      : "Día de pago"
                    : "Cargando..."}
                </b>
                con una prorroga hasta
                <b className="ml-1" style={{ textDecoration: "underline" }}>
                  {configDate.data
                    ? configDate.data.delay_at
                      ? `${configDate.data.delay_at} días después de la fecha de cobro.`
                      : "Día de prorroga"
                    : "Cargando..."}
                </b>
                .
              </p>
            </Col>
          </Row>
          <Row value={false}>
            <Col
              xs="auto"
              className="d-flex align-items-center justify-content-center"
            >
              <FontAwesomeIcon icon={faInfo} />
            </Col>
            <Col className="d-flex align-items-center">
              <p className="mb-0">
                Aún no se ha configurado la finanzas del condominio.
              </p>
            </Col>
          </Row>
        </PreloadState>
      </Alert>
      <CardDeck className="mb-2">
        <Card>
          <FalconCardHeader
            title={"Resumen financiero del propietario"}
            className="text-center"
          />
          <CardBody className="fs--1 p-0">
            <Row>
              <Col>
                <Alert color="secondary">
                  <p className="fs--1 mb-0">
                    <FontAwesomeIcon
                      icon="exchange-alt"
                      transform="rotate-90"
                      className="mr-2"
                    />
                    El último movimiento del condominio fue de
                    <strong className="ml-1 mr-1">
                      <NumberFormat
                        value={
                          movementsData[0]?.amount ? movementsData[0].amount : 0
                        }
                        prefix={`${baseCurrency.symbol} `}
                        thousandSeparator
                        decimalScale={2}
                        fixedDecimalScale
                        displayType="text"
                      />
                    </strong>
                    {movementsData[0]
                      ? "Actualizado el " +
                        getDate(movementsData[0]?.created_at)
                      : "Sin actualizaciones recientes"}
                    .
                    <strong className="ml-1 mr-1">
                      {movementsData[0]
                        ? "Revisar " +
                          getStringDate(movementsData[0]?.created_at)
                        : ""}
                    </strong>
                  </p>
                </Alert>
              </Col>
            </Row>
            <CardSummary
              content="430,594"
              title="Saldo actual"
              color={balance.data >= 0 ? "sucess" : "danger"}
              to="#"
              linkText={null}
            >
              <PreloadState
                cond={!!balance.data}
                loading={balance.loading}
                loadingClass="p-0"
              >
                <Row value={true}>
                  <Col xs={12}>
                    <NumberFormat
                      value={balance.data}
                      prefix={`${baseCurrency.symbol} `}
                      thousandSeparator
                      decimalScale={2}
                      fixedDecimalScale
                      displayType="text"
                    />
                    <NumberFormat
                      className="text-right"
                      displayType="text"
                      allowedDecimalSeparators={true}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale
                      prefix={" | " + curr?.currency?.iso + " "}
                      value={balance.data * Number(curr?.value || 0)}
                    />
                  </Col>
                  <Col className="d-flex justify-content-between align-items-center">
                    <PreloadState cond={balance.data >= 0}>
                      <Or>
                        <span className="text-success fs--1">
                          **Utiliza tu saldo para estar al día con tus pagos.
                        </span>
                      </Or>
                      <div className="d-flex align-items-center justify-content-end">
                        <Dropdown
                          isOpen={isOpen}
                          toggle={() => setIsOpen(!isOpen)}
                        >
                          <DropdownToggle
                            caret
                            className="btn btn-falcon-default d-flex align-items-center justify-content-between"
                          >
                            Saldos a favor
                          </DropdownToggle>
                          <DropdownMenu right>
                            <DropdownItem header>Opciones</DropdownItem>
                            <DropdownItem
                              tag={Link}
                              to="/dashboard/my/finance/advance/add"
                            >
                              <FontAwesomeIcon
                                icon={faDollarSign}
                                className="mr-2"
                              />
                              Registrar saldo a favor
                            </DropdownItem>
                            <DropdownItem
                              tag={Link}
                              to="/dashboard/my/finance/advance"
                            >
                              <FontAwesomeIcon icon={faList} className="mr-2" />
                              Ver mis saldos a favor
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </PreloadState>
                  </Col>
                </Row>
              </PreloadState>
            </CardSummary>
            <CardSummary
              content="430,594"
              title="Cuentas por pagar"
              color={amount !== 0 ? "danger" : "sucess"}
              to="#"
              linkText={null}
            >
              <PreloadState
                cond={!!amount}
                loading={balance.loading}
                loadingClass="p-0"
              >
                <Row value={true}>
                  <Col xs={12}>
                    <NumberFormat
                      value={amount}
                      prefix={`${baseCurrency.symbol} `}
                      thousandSeparator
                      decimalScale={2}
                      fixedDecimalScale
                      displayType="text"
                    />
                    <NumberFormat
                      className="text-right"
                      displayType="text"
                      allowedDecimalSeparators={true}
                      thousandSeparator={true}
                      decimalScale={2}
                      fixedDecimalScale
                      prefix={" | " + curr?.currency?.iso + " "}
                      value={amountBs ?? amount * Number(curr?.value || 0)}
                    />
                  </Col>
                  <Col className="d-flex justify-content-between align-items-center mt-2">
                    <PreloadState cond={amount === 0}>
                      <Or value={true}>
                        <span className="text-success fs--1">
                          ¡Estas al dia!
                        </span>
                      </Or>
                      <Or value={false}>
                        <span className="text-danger fs--1">
                          **Asegurate de estar al día con tus pagos.
                        </span>
                      </Or>
                    </PreloadState>
                  </Col>
                </Row>
              </PreloadState>
            </CardSummary>
          </CardBody>

          <Card className="mb-2">
            <FalconCardHeader title="" className="p-0">
              <Row>
                <Col>
                  <Row className="justify-content-center mb-3">
                    <Col
                      xs="auto"
                      lg="auto"
                      md={12}
                      sm={12}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <Label className="mb-0 mr-2">
                        <FontAwesomeIcon icon={faFilter} />
                      </Label>
                    </Col>
                    <Col
                      xs="auto"
                      sm="auto"
                      lg="auto"
                      className="d-flex align-items-center flex-sm-column flex-md-column flex-lg-row"
                    >
                      <Label className="mr-2 mb-0">Desde</Label>
                      <Datetime
                        value={formDate.since}
                        isValidDate={(current, selected) => {
                          return !current.isAfter();
                        }}
                        onChange={(d) =>
                          setformDate((prev) => ({
                            ...prev,
                            since: d,
                          }))
                        }
                        dateFormat="DD/MM/YYYY"
                        timeFormat={false}
                      />
                    </Col>
                    <Col
                      xs="auto"
                      sm="auto"
                      lg="auto"
                      className="d-flex align-items-center flex-sm-column flex-md-column flex-lg-row"
                    >
                      <Label className="mr-2 mb-0">Hasta</Label>
                      <Datetime
                        value={formDate.to}
                        className="mr-2"
                        isValidDate={(current, selected) => {
                          return (
                            current.isAfter(formDate.since) &&
                            !current.isAfter()
                          );
                        }}
                        dateFormat="DD/MM/YYYY"
                        timeFormat={false}
                        onChange={(d) =>
                          setformDate((prev) => ({ ...prev, to: d }))
                        }
                      />
                    </Col>
                    <Col
                      xs="auto"
                      className="pl-0 d-flex align-items-md-end align-items-lg-center align-items-sm-end"
                    >
                      <ButtonIcon
                        className="text-nowrap d-sm-none d-lg-block"
                        disabled={!formDate.to}
                        icon={faSearch}
                        color="falcon-default"
                        onClick={() => {
                          setParams((prev) => {
                            return {
                              ...prev,
                              start_date: formDate.since.format("YYYY-MM-DD"),
                              end_date: formDate.to.format("YYYY-MM-DD"),
                            };
                          });
                        }}
                      >
                        Buscar
                      </ButtonIcon>
                      <Button
                        className="text-nowrap d-sm-block d-lg-none"
                        disabled={!formDate.to}
                        color="falcon-default"
                        onClick={() => {
                          setParams((prev) => {
                            return {
                              ...prev,
                              start_date: formDate.since.format("YYYY-MM-DD"),
                              end_date: formDate.to.format("YYYY-MM-DD"),
                            };
                          });
                        }}
                      >
                        <FontAwesomeIcon icon={faSearch} />
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FalconCardHeader>
            {movementsData.length > 0 ? (
              <>
                <Fragment>
                  <Table striped bordered hover>
                    <thead>
                      <tr>
                        <th>Fecha</th>
                        <th>Descripción</th>
                        <th>Tipo</th>
                        <th>Monto</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((movement) => (
                        <tr key={movement.id}>
                          <td>{getDate(movement.created_at)}</td>

                          <td>
                            {movement.description.message
                              ? movement.description.message
                              : movement.description}{" "}
                          </td>
                          <td>
                            {movement.isDecrement === 0 ? (
                              <Badge className="rounded-capsule badge-soft-success">
                                Ingreso
                                <FontAwesomeIcon
                                  className="ml-2 "
                                  icon="fa-solid fa-arrow-up"
                                />
                              </Badge>
                            ) : (
                              <Badge className="rounded-capsule badge-soft-warning">
                                Egreso
                                <FontAwesomeIcon
                                  className="ml-2"
                                  icon="fa-solid fa-arrow-down"
                                />
                              </Badge>
                            )}
                          </td>
                          <td>
                            {" "}
                            <Row>
                              <Col>
                                <NumberFormat
                                  className="text-right"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  prefix={`${baseCurrency.symbol} `}
                                  value={movement.amount}
                                />
                                <NumberFormat
                                  className="text-right"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  prefix={" | " + curr?.currency?.iso + " "}
                                  value={
                                    movement.amount * Number(curr?.value || 0)
                                  }
                                />
                              </Col>
                            </Row>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <FullPagination
                    nextPage={movementsNextPage}
                    prevPage={movementsPreviousPage}
                    goToPage={movementsGoToPage}
                    meta={movementsMeta}
                    className={"shadow-none"}
                    posText={"Movimientos"}
                    perPage={movementsPerPage}
                  />
                </Fragment>
              </>
            ) : (
              <Row className="p-card">
                <Col>
                  <Alert color="info" className="mb-0">
                    Al parecer aún no hay movimientos para mostrar.
                  </Alert>
                </Col>
              </Row>
            )}
          </Card>
        </Card>
      </CardDeck>

      <PreloadState loading={false} cond={!!configSetted}>
        <Or value={true}>
          <Card className="mb-3">
            <Button color="falcon-default" onClick={handleSeeToPay}>
              <FalconCardHeader
                title={"Mis cuentas por pagar"}
                subtitle={"Presiona para gestionar"}
              />
            </Button>
            <CardBody className="fs--1 p-0">
              <PreloadState
                cond={isIterableArray(data)}
                loading={periodsIsLoading}
              >
                <Or value={true}>
                  <>
                    {data.map((period) => (
                      <Fragment key={period.id}>
                        <Row
                          onClick={() => togglePeriod(period.id)}
                          className="border-top mx-0 py-3 px-3 cursor-pointer align-items-center"
                          noGutters
                        >
                          <Col className="d-flex align-items-center">
                            <FontAwesomeIcon
                              icon="caret-right"
                              transform={
                                openPeriods[period.id] ? "rotate-90" : undefined
                              }
                              className="mr-2 text-600"
                            />
                            <span className="font-weight-semi-bold text-900">
                              {period.name}
                            </span>
                            {period.control_number && (
                              <span className="ml-2 fs--1 text-600">
                                N° de control {period.control_number}
                              </span>
                            )}
                          </Col>
                          <Col xs="auto" className="text-right text-nowrap">
                            <NumberFormat
                              displayType="text"
                              thousandSeparator
                              decimalScale={2}
                              fixedDecimalScale
                              prefix={`${baseCurrency.symbol} `}
                              value={period.total_amount}
                            />
                            <NumberFormat
                              className="ml-1"
                              displayType="text"
                              thousandSeparator
                              decimalScale={2}
                              fixedDecimalScale
                              prefix={" | " + curr?.currency?.iso + " "}
                              value={period.total_amount_bs ?? period.total_amount * Number(curr?.value || 0)}
                            />
                          </Col>
                        </Row>
                        <Collapse isOpen={!!openPeriods[period.id]}>
                          {isIterableArray(period.accounts) ? (
                            <Table striped responsive className="mb-0">
                              <thead>
                                <tr>
                                  <th>Cuenta</th>
                                  <th>Detalles</th>
                                  <th className="text-center">Monto</th>
                                  <th className="text-right">Expira</th>
                                </tr>
                              </thead>
                              <tbody>
                                {period.accounts.map((debt) => (
                                  <PropertyDebtToPayRow key={debt.id} debt={debt} />
                                ))}
                              </tbody>
                            </Table>
                          ) : null}
                          {period.accounts_count > period.accounts.length && (
                            <Button
                              color="link"
                              size="sm"
                              className="d-block m-2 mb-3"
                              onClick={handleSeeToPay}
                            >
                              Mostrando {period.accounts.length} de{" "}
                              {period.accounts_count} cuentas, ver todas
                            </Button>
                          )}
                          {!isIterableArray(period.accounts) && (
                            <Alert color="info" className="m-2 mb-0">
                              Sin cuentas pendientes para este período.
                            </Alert>
                          )}
                        </Collapse>
                      </Fragment>
                    ))}
                    <FullPagination
                      nextPage={periodsNextPage}
                      prevPage={periodsPreviousPage}
                      goToPage={periodsGoToPage}
                      meta={periodsMeta}
                      className={"shadow-none"}
                      posText={"Periodos"}
                      perPage={periodsPerPage}
                    />
                  </>
                </Or>
                <Or value={false}>
                  <Row className="p-card">
                    <Col>
                      <Alert color="info" className="mb-0">
                        {
                          "Al parecer todavía no hay cuentas por pagar para mostrar de tu condominio"
                        }
                      </Alert>
                    </Col>
                  </Row>
                </Or>
              </PreloadState>
            </CardBody>
          </Card>
          <Card className="mb-3">
            <Button color="falcon-default" onClick={handleSeePays}>
              <FalconCardHeader
                title={"Mis pagos"}
                subtitle={"Presiona para gestionar"}
              />
            </Button>
            <CardBody className="fs--1 p-0">
              <PreloadState
                cond={isIterableArray(myPays.data)}
                loading={myPays.loading}
              >
                <Or value={true}>
                  <Table responsive striped>
                    <thead>
                      <tr>
                        <th>Referencia</th>
                        <th>Fecha de transacción</th>
                        <th className="text-center">Monto</th>
                        <th className="text-right">Estado</th>
                      </tr>
                    </thead>
                    <tbody>
                      {myPays.data?.map(
                        (pay, i) =>
                          i < 5 && (
                            <tr key={i}>
                              <td>
                                <Link
                                  to={{
                                    pathname: `/dashboard/my/finance/pays/${pay.id}`,
                                    state: {
                                      amount: pay.amount,
                                      propertyDebtId: pay.created_at,
                                      date: pay.created_at,
                                      aliquot: pay.aliquot,
                                    },
                                  }}
                                >
                                  {pay.reference &&
                                  pay.reference !== "undefined"
                                    ? pay?.reference.toUpperCase()
                                    : "Código de referencia no agregado"}
                                </Link>
                                {pay.control_number && (
                                  <div className="fs--1 text-600">
                                    N° de control {pay.control_number}
                                  </div>
                                )}
                              </td>
                              <td>
                                {moment(pay.created_at).format("DD-MM-YYYY")}
                              </td>
                              <td className="text-center">
                                <NumberFormat
                                  displayType="text"
                                  thousandSeparator
                                  decimalScale={2}
                                  fixedDecimalScale
                                  prefix={`${baseCurrency.symbol} `}
                                  value={pay.amount}
                                />
                                <NumberFormat
                                  className="text-right"
                                  displayType="text"
                                  allowedDecimalSeparators={true}
                                  thousandSeparator={true}
                                  decimalScale={2}
                                  fixedDecimalScale
                                  prefix={" | " + curr?.currency?.iso + " "}
                                  value={pay.amount * resolvePayDisplayRate(pay)}
                                />
                              </td>
                              <td className="text-right">
                                <Badge
                                  className="rounded-pill"
                                  color={
                                    pay.status === "pending"
                                      ? "warning"
                                      : pay.status === "refused"
                                      ? "danger"
                                      : pay.status === "canceled"
                                      ? "info"
                                      : pay.status === "voided"
                                      ? "secondary"
                                      : "success"
                                  }
                                >
                                  {pay.status === "pending"
                                    ? "Pendiente"
                                    : pay.status === "refused"
                                    ? "Pago rechazado"
                                    : pay.status === "canceled"
                                    ? "Cancelado"
                                    : pay.status === "voided"
                                    ? "Anulado"
                                    : "Aprobado"}
                                </Badge>
                              </td>
                            </tr>
                          )
                      )}
                    </tbody>
                  </Table>
                </Or>
                <Or value={false} cond={!!myPays.error}>
                  <Row value={true} className="p-card">
                    <Col>
                      <Alert color="danger" className="mb-0">
                        Ha ocurrido un error inesperado, intente nuevamente más
                        tarde.
                      </Alert>
                    </Col>
                  </Row>
                  <Row value={false} className="p-card">
                    <Col>
                      <Alert color="info" className="mb-0">
                        {"Al parecer todavía no hay pagos."}
                      </Alert>
                    </Col>
                  </Row>
                </Or>
              </PreloadState>
            </CardBody>
          </Card>
          {aliquots && (
            <Card className="mb-3">
              <FalconCardHeader
                title={"Mi alícuota"}
                titleClass="text-center"
              />
              <CardBody className="fs--1 p-0">
                <PreloadState
                  cond={!!aliquots?.data?.id}
                  loading={aliquots.loading}
                >
                  <Or value={true}>
                    <Table responsive striped>
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Descripción de la alícuota</th>
                          <th className="text-right">Porcentaje</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{aliquots.data.id}</td>
                          <td>{aliquots.data.description}</td>
                          <td className="text-right">
                            <NumberFormat
                              displayType="text"
                              thousandSeparator
                              decimalScale={4}
                              fixedDecimalScale
                              prefix="%"
                              value={aliquots.data.value}
                            />
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Or>
                  <Or
                    value={false}
                    cond={!!(aliquots.error && aliquots.data?.length === 0)}
                  >
                    <Row value={true} className="p-card">
                      <Col>
                        <Alert color="danger" className="mb-0">
                          Ha ocurrido un error inesperado, intente nuevamente
                          más tarde.
                        </Alert>
                      </Col>
                    </Row>
                    <Row value={false} className="p-card">
                      <Col>
                        <Alert color="info" className="mb-0">
                          {"Al parecer no cuentas con alícuotas por pagar."}
                        </Alert>
                      </Col>
                    </Row>
                  </Or>
                </PreloadState>
              </CardBody>
            </Card>
          )}
          <CardDeck className="mb-3">
            <Card>
              <Button
                color="falcon-default"
                className="p-0"
                onClick={handleSeeReports}
              >
                <FalconCardHeader
                  title="Reportes"
                  subtitle={"Presiona para gestionar"}
                />
              </Button>
            </Card>
          </CardDeck>
        </Or>
        <PreloadState value={false} loading={loadingConfig}>
          <Alert color="warning" className="shadow-sm">
            <Row>
              <Col
                xs="auto"
                className="d-flex justify-content-center align-items-center"
              >
                <FontAwesomeIcon icon={faExclamationTriangle} size={"lg"} />
              </Col>
              <Col className="d-flex justify-content-cente flex-column">
                <h4 className="alert-heading">
                  ¡Configuración de días de cobro del condominio necesaria!
                </h4>
                <p className="mb-0">
                  Para poder acceder a las finanzas del condominio se necesita
                  configurar los días de cobro, informa a tu administrador.
                </p>
              </Col>
            </Row>
          </Alert>
        </PreloadState>
      </PreloadState>
    </>
  );
};

export default withRedirect(MyFinance);
